import { iconStyle } from 'components/icons/_iconStyle'
import { cx } from 'linaria'

export const ErrorIcon = ({ className, ...rest }) => (
  <span className={cx(iconStyle, 'icon', className && className)} {...rest}>
    <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fillRule="evenodd" clipRule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 2c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z"/><path d="M13.5 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM13.736 7.982l-.604 4.527a1.142 1.142 0 0 1-2.264 0l-.604-4.527a1.751 1.751 0 1 1 3.472 0Z"/></svg>
  </span>
)
  
